/* eslint-disable */
// @ts-nocheck

/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';


function updateSalesAcknowledgementDateQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


export function updateSalesAcknowledgementDateInput(
    updateSalesOrder:
        DataServiceEntities.IUpdateSalesOrderEntity
): IDataServiceRequest {
    const query = updateSalesAcknowledgementDateQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateSalesAcknowledgementDate',
        true,
        DataServiceEntities.UpdateSaleAcknowledgementDateResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IUpdateSaleAcknowledgementDateResponse' },
        {
            updateSalesOrder: updateSalesOrder
        }
    );
}

export function updateSalesAcknowledgementDateAsync(
    context: IContext, updateSalesOrder:
        DataServiceEntities.IUpdateSalesOrderEntity
): AsyncResult<DataServiceEntities.IUpdateSaleAcknowledgementDateResponse> {
    const request = updateSalesAcknowledgementDateInput(updateSalesOrder);
    return callActionOrExecute<DataServiceEntities.IUpdateSaleAcknowledgementDateResponse>(request, context.callerContext);
}

function getTableDataQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


export function getTableDataInput(
    tableName:
        string
): IDataServiceRequest {
    const query = getTableDataQuery();
    return query.createDataServiceRequestForOperation(
        'GetTableData',
        true,
        ''
        ,
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            tableName: tableName
        }
    );
}

export function getTableDataAsync(
    context: IContext, tableName:
        string
): AsyncResult<string> {
    const request = getTableDataInput(tableName);
    return callActionOrExecute<string>(request, context.callerContext);
}

function initiateReturnRequestQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


export function initiateReturnRequestInput(
    salesLineRecId:
        number[],
    qtyToReturn:
        number[],
    returnReasonCode:
        string[]
): IDataServiceRequest {
    const query = initiateReturnRequestQuery();
    return query.createDataServiceRequestForOperation(
        'InitiateReturnRequest',
        true,
        DataServiceEntities.ReturnRequestResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IReturnRequestResponse' },
        {
            salesLineRecId: salesLineRecId,
            qtyToReturn: qtyToReturn,
            returnReasonCode: returnReasonCode
        }
    );
}

export function initiateReturnRequestAsync(
    context: IContext, salesLineRecId:
        number[],
    qtyToReturn:
        number[],
    returnReasonCode:
        string[]
): AsyncResult<DataServiceEntities.IReturnRequestResponse> {
    const request = initiateReturnRequestInput(salesLineRecId, qtyToReturn, returnReasonCode);
    return callActionOrExecute<DataServiceEntities.IReturnRequestResponse>(request, context.callerContext);
}


// @ts-ignore
function administratorsQuery(id?: string): DataServiceQuery {
    const key = (id) ? { Id: id } : null;
    return new DataServiceQuery("Administrators", "ApiResponseEntity_1OfAdministratorEntity", DataServiceEntities.ApiResponseEntity_1OfAdministratorEntityExtensionClass, key);
}


export function createGetByIdInput(administrator: DataServiceEntities.IAdministratorCriteria): IDataServiceRequest {
    const query = administratorsQuery();
    return query.createDataServiceRequestForOperation('GetById', true, DataServiceEntities.ApiResponseEntity_1OfAdministratorEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity' }, { Administrator: administrator });
}


export function getByIdAsync(context: IContext, administrator: DataServiceEntities.IAdministratorCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity> {
    const request = createGetByIdInput(administrator);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity>(request, context.callerContext);
}

export function createGetByEmailInput(administrator: DataServiceEntities.IAdministratorCriteria): IDataServiceRequest {
    const query = administratorsQuery();
    return query.createDataServiceRequestForOperation('GetByEmail', true, DataServiceEntities.ApiResponseEntity_1OfAdministratorEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity' }, { Administrator: administrator });
}


export function getByEmailAsync(context: IContext, administrator: DataServiceEntities.IAdministratorCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity> {
    const request = createGetByEmailInput(administrator);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity>(request, context.callerContext);
}

export function createSearchByLocationInput(administrator: DataServiceEntities.IAdministratorLocationCriteria): IDataServiceRequest {
    const query = administratorsQuery();
    return query.createDataServiceRequestForOperation('SearchByLocation', true, DataServiceEntities.ApiResponseEntity_1OfList_1OfAdministratorEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfList_1OfAdministratorEntity' }, { Administrator: administrator });
}


export function searchByLocationAsync(context: IContext, administrator: DataServiceEntities.IAdministratorLocationCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfList_1OfAdministratorEntity> {
    const request = createSearchByLocationInput(administrator);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfList_1OfAdministratorEntity>(request, context.callerContext);
}

export function createApplyInput(administrator: DataServiceEntities.IAdministratorCriteria): IDataServiceRequest {
    const query = administratorsQuery();
    return query.createDataServiceRequestForOperation('Apply', true, DataServiceEntities.ApiResponseEntity_1OfAdministratorEntityExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity' }, { Administrator: administrator });
}


export function applyAsync(context: IContext, administrator: DataServiceEntities.IAdministratorCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity> {
    const request = createApplyInput(administrator);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity>(request, context.callerContext);
}

export function createEditInput(administrator: DataServiceEntities.IAdministratorCriteria): IDataServiceRequest {
    const query = administratorsQuery();
    return query.createDataServiceRequestForOperation('Edit', true, DataServiceEntities.ApiResponseEntity_1OfAdministratorEntityExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity' }, { Administrator: administrator });
}


export function editAsync(context: IContext, administrator: DataServiceEntities.IAdministratorCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity> {
    const request = createEditInput(administrator);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfAdministratorEntity>(request, context.callerContext);
}


// @ts-ignore
function customerOperationsQuery(id?: string): DataServiceQuery {
    const key = (id) ? { Id: id } : null;
    return new DataServiceQuery("CustomerOperations", "ApiResponseEntity_1OfString", DataServiceEntities.ApiResponseEntity_1OfStringExtensionClass, key);
}


export function creatersmCustRequestInvoiceCopyInput(custRequestInvoice: DataServiceEntities.ICustRequestInvoiceCriteria): IDataServiceRequest {
    const query = customerOperationsQuery();
    return query.createDataServiceRequestForOperation('rsmCustRequestInvoiceCopy', true, DataServiceEntities.ApiResponseEntity_1OfStringExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfString' }, { CustRequestInvoice: custRequestInvoice });
}


export function rsmCustRequestInvoiceCopyAsync(context: IContext, custRequestInvoice: DataServiceEntities.ICustRequestInvoiceCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfString> {
    const request = creatersmCustRequestInvoiceCopyInput(custRequestInvoice);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfString>(request, context.callerContext);
}


// @ts-ignore
function vitalSourceQuery(id?: string): DataServiceQuery {
    const key = (id) ? { Id: id } : null;
    return new DataServiceQuery("VitalSource", "ApiResponseEntity_1OfIEnumerable_1OfVitalSourceRedemptionCodesEntity", DataServiceEntities.ApiResponseEntity_1OfIEnumerable_1OfVitalSourceRedemptionCodesEntityExtensionClass, key);
}


export function createRedeemCodeInput(redeemCriteria: DataServiceEntities.IRedeemCriteria): IDataServiceRequest {
    const query = vitalSourceQuery();
    return query.createDataServiceRequestForOperation('RedeemCode', true, DataServiceEntities.ApiResponseEntity_1OfStringExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfString' }, { redeemCriteria: redeemCriteria });
}


export function redeemCodeAsync(context: IContext, redeemCriteria: DataServiceEntities.IRedeemCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfString> {
    const request = createRedeemCodeInput(redeemCriteria);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfString>(request, context.callerContext);
}

export function createGetLicensesInput(criteria: DataServiceEntities.IGetLicensesCriteria): IDataServiceRequest {
    const query = vitalSourceQuery();
    return query.createDataServiceRequestForOperation('GetLicenses', true, DataServiceEntities.ApiResponseEntity_1OfList_1OfLicenseEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfList_1OfLicenseEntity' }, { Criteria: criteria });
}


export function getLicensesAsync(context: IContext, criteria: DataServiceEntities.IGetLicensesCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfList_1OfLicenseEntity> {
    const request = createGetLicensesInput(criteria);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfList_1OfLicenseEntity>(request, context.callerContext);
}


// @ts-ignore
function studentsQuery(id?: string): DataServiceQuery {
    const key = (id) ? { Id: id } : null;
    return new DataServiceQuery("Students", "ApiResponseEntity_1OfIEnumerable_1OfStudentEntity", DataServiceEntities.ApiResponseEntity_1OfIEnumerable_1OfStudentEntityExtensionClass, key);
}


export function createGetStudentsInput(studentsIds: string[]): IDataServiceRequest {
    const query = studentsQuery();
    return query.createDataServiceRequestForOperation('GetStudents', true, DataServiceEntities.ApiResponseEntity_1OfList_1OfStudentEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfList_1OfStudentEntity' }, { studentsIds: studentsIds });
}


export function getStudentsAsync(context: IContext, studentsIds: string[]): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfList_1OfStudentEntity> {
    const request = createGetStudentsInput(studentsIds);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfList_1OfStudentEntity>(request, context.callerContext);
}

export function createSearchStudentByCustomerIdInput(customerId: string): IDataServiceRequest {
    const query = studentsQuery();
    return query.createDataServiceRequestForOperation('SearchStudentByCustomerId', true, DataServiceEntities.ApiResponseEntity_1OfList_1OfStudentEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfList_1OfStudentEntity' }, { customerId: customerId });
}


export function searchStudentByCustomerIdAsync(context: IContext, customerId: string): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfList_1OfStudentEntity> {
    const request = createSearchStudentByCustomerIdInput(customerId);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfList_1OfStudentEntity>(request, context.callerContext);
}

export function createCreateStudentInput(student: DataServiceEntities.IStudentEntity): IDataServiceRequest {
    const query = studentsQuery();
    return query.createDataServiceRequestForOperation('CreateStudent', true, DataServiceEntities.ApiResponseEntity_1OfStudentEntityExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfStudentEntity' }, { student: student });
}


export function createStudentAsync(context: IContext, student: DataServiceEntities.IStudentEntity): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfStudentEntity> {
    const request = createCreateStudentInput(student);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfStudentEntity>(request, context.callerContext);
}

export function createEditStudentInput(student: DataServiceEntities.IStudentEntity): IDataServiceRequest {
    const query = studentsQuery();
    return query.createDataServiceRequestForOperation('EditStudent', true, DataServiceEntities.ApiResponseEntity_1OfStudentEntityExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfStudentEntity' }, { student: student });
}


export function editStudentAsync(context: IContext, student: DataServiceEntities.IStudentEntity): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfStudentEntity> {
    const request = createEditStudentInput(student);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfStudentEntity>(request, context.callerContext);
}

export function createDeleteStudentInput(studentId: string): IDataServiceRequest {
    const query = studentsQuery();
    return query.createDataServiceRequestForOperation('DeleteStudent', true, DataServiceEntities.ApiResponseEntity_1OfBooleanExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfBoolean' }, { studentId: studentId });
}


export function deleteStudentAsync(context: IContext, studentId: string): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfBoolean> {
    const request = createDeleteStudentInput(studentId);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfBoolean>(request, context.callerContext);
}


// @ts-ignore
function testInstanceQuery(id?: string): DataServiceQuery {
    const key = (id) ? { Id: id } : null;
    return new DataServiceQuery("TestInstance", "ApiResponseEntity_1OfIEnumerable_1OfTestInstanceEntity", DataServiceEntities.ApiResponseEntity_1OfIEnumerable_1OfTestInstanceEntityExtensionClass, key);
}


export function createGetDownloadLinkInput(testInstance: DataServiceEntities.ITestInstanceDownloadCriteria): IDataServiceRequest {
    const query = testInstanceQuery();
    return query.createDataServiceRequestForOperation('GetDownloadLink', true, DataServiceEntities.ApiResponseEntity_1OfStringExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfString' }, { testInstance: testInstance });
}


export function getDownloadLinkAsync(context: IContext, testInstance: DataServiceEntities.ITestInstanceDownloadCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfString> {
    const request = createGetDownloadLinkInput(testInstance);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfString>(request, context.callerContext);
}

export function createSearchByCustomerInput(testInstance: DataServiceEntities.ITestInstanceSearchCriteria): IDataServiceRequest {
    const query = testInstanceQuery();
    return query.createDataServiceRequestForOperation('SearchByCustomer', true, DataServiceEntities.ApiResponseEntity_1OfPagedResult_1OfTestInstanceEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfPagedResult_1OfTestInstanceEntity' }, { testInstance: testInstance });
}


export function searchByCustomerAsync(context: IContext, testInstance: DataServiceEntities.ITestInstanceSearchCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfPagedResult_1OfTestInstanceEntity> {
    const request = createSearchByCustomerInput(testInstance);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfPagedResult_1OfTestInstanceEntity>(request, context.callerContext);
}

export function createSearchByAdministratorInput(testInstance: DataServiceEntities.ITestInstanceSearchCriteria): IDataServiceRequest {
    const query = testInstanceQuery();
    return query.createDataServiceRequestForOperation('SearchByAdministrator', true, DataServiceEntities.ApiResponseEntity_1OfPagedResult_1OfTestInstanceEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfPagedResult_1OfTestInstanceEntity' }, { testInstance: testInstance });
}


export function searchByAdministratorAsync(context: IContext, testInstance: DataServiceEntities.ITestInstanceSearchCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfPagedResult_1OfTestInstanceEntity> {
    const request = createSearchByAdministratorInput(testInstance);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfPagedResult_1OfTestInstanceEntity>(request, context.callerContext);
}


// @ts-ignore
function testSessionsQuery(id?: string): DataServiceQuery {
    const key = (id) ? { Id: id } : null;
    return new DataServiceQuery("TestSessions", "ApiResponseEntity_1OfIEnumerable_1OfTestSessionEntity", DataServiceEntities.ApiResponseEntity_1OfIEnumerable_1OfTestSessionEntityExtensionClass, key);
}


export function createSearchInput(testSessionSearchCriteria: DataServiceEntities.ITestSessionsSearchCriteria): IDataServiceRequest {
    const query = testSessionsQuery();
    return query.createDataServiceRequestForOperation('Search', true, DataServiceEntities.ApiResponseEntity_1OfList_1OfTestSessionEntityExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IApiResponseEntity_1OfList_1OfTestSessionEntity' }, { testSessionSearchCriteria: testSessionSearchCriteria });
}


export function searchAsync(context: IContext, testSessionSearchCriteria: DataServiceEntities.ITestSessionsSearchCriteria): AsyncResult<DataServiceEntities.IApiResponseEntity_1OfList_1OfTestSessionEntity> {
    const request = createSearchInput(testSessionSearchCriteria);
    return callActionOrExecute<DataServiceEntities.IApiResponseEntity_1OfList_1OfTestSessionEntity>(request, context.callerContext);
}
